// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { withRouter } from 'react-router-dom';

import Modal from './Modal';

class InviteUser extends Modal {

    state = {
        email: "",
        alert: false
    }

    renderContent = () => {

        const team = this.props.team && this.props.team._id && this.props.team.billing && this.props.team.users ? {
            ...this.props.team,
            users: this.props.team.users.filter(user => !user.email.endsWith("@stax.ai"))
        } : {
            _id: null,
            billing: { plan: {
            tier: "Personal",
            limits: {
                maxUsers: 1
            }
            } },
            users: []
        };

        const tier = team.billing.plan.tier;
        const maxUsers = tier === "Pro" ? 30 : tier === "Personal" ? 1 : team.billing.plan.limits.maxUsers;

        return (<div className="modal-content modal-center">
            
            <br /><br />

            <h1>Invite a new user!</h1>

            <p>
                Get your entire team on Stax·ai so they can access your team's documents and collaborate with you!<br />
                Team members on Stax·ai can upload new files, comment on documents, make notes, sign and send documents, and much more!<br />
            </p>

            <br />

            {maxUsers > team.users.filter(u => !u.email.includes("@stax.ai")).length ? <>
                <h2>What's the user's email address?</h2>

                <form
                    onSubmit={async (e) => {

                        e.preventDefault();
                        e.stopPropagation();

                        const email = this.state.email;

                        if (!email || email === "" || !email.includes("@"))
                            return this.alert();

                        await this.setState({ email: "" });
                        await this.props.modal();
                        await this.props.inviteUser(email);
                    }}
                >

                    <input
                        id="email"
                        name="email"
                        type="text"
                        className={"input-inline-text" + (this.state.alert ? " input-error" : "")}
                        placeholder="Enter email address..."
                        style={{ width: 330 }}
                        value={this.state.email}
                        onClick={e => e.stopPropagation()}
                        onChange={e => this.setState({ email: e.target.value, alert: false })}
                    />

                    <input
                        type="submit"
                        value="Send Invite"
                        className="input-inline-submit"
                    />
                
                </form>
            </> : <>

                <h2>You have reached your plan limit</h2>

                <p>
                    Looks like you already have <strong>{team.users.length}</strong> users on your plan.
                    <br />
                    If that's not enough, you can upgrade your team's plan:
                </p>

                <div
                    className="button"
                    style={{
                        float: 'none',
                        backgroundImage: "url('https://static.stax.ai/images/icons/upgrade.png')"
                    }}
                    onClick={async () => {
                        await this.props.modal();
                        this.props.history.push("/settings/billing");
                    }}
                >Upgrade Plan</div>

            </>}
            
        </div>);
    }

};

export default withRouter(InviteUser);